/**
 * @param array - array of objects
 * @param key - key of the object to use as the key in the map
 * @returns - object with the key as the key and the object as the value
 * @example - createMap([{ ID: 1, name: 'John' }, { ID: 2, name: 'Doe' }], 'ID')
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createMap = <V extends any[], K extends keyof V[number]>(
  array: V,
  key: K
) => {
  const map = new Map<V[number][K], V[number]>();

  array.forEach((item) => {
    map.set(item[key], item);
  });

  return map;
};

/**
 * Creates a grouped map of objects with the key as the key and the array of objects as the value.
 *
 * @param array - array of objects
 * @param key - key of the object to use as the key in the map
 * @returns - object with the key as the key and the object as the value
 * @example - createGroupedMap([{ ID: 1, name: 'John' }, { ID: 2, name: 'Doe' }], 'ID')
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createGroupedMap = <V extends any[], K extends keyof V[number]>(
  array: V,
  key: K
) => {
  const map = new Map<V[number][K], V[number][]>();

  array.forEach((item) => {
    const arr = map.get(item[key]);

    if (arr) {
      arr.push(item);
    } else {
      map.set(item[key], [item]);
    }
  });

  return map;
};
